$(document).ready(function() {
  if (Modernizr.touch) {
    mobileHandler();
    $(window).on("load resize orientationchange", update_width);
  }
});

var update_width = function()  {
  var screen_width  = $(window).width();
  if (screen_width < 900) {
    $(".content").css("width", screen_width);
  }
}
var mobileHandler = function() {
/* disables scrolling when use keyboard on mobile device */
  $("input, textarea").on('focusin', function(){
    $("body").bind('touchmove', function(){
      return false;
    });
  });
  $("input, textarea").on('focusout', function(){
    $("body").unbind('touchmove');
  });
}
